import { Section } from '~/shared/section/Section';
import { SectionTitle } from '~/shared/section/SectionTitle';
import { useChart } from '~/features/admissions/charts/ChartContext';
import { PlanOfCareReviewTable } from '~/features/qa/poc-reviews/PlanOfCareReviewTable';

export function PlanOfCareReviewRoute() {
	const { stayId, certificationPeriodId } = useChart();
	return (
		<Section header={<SectionTitle title="Plan of Care Reviews" />}>
			<PlanOfCareReviewTable hideColumns={['patientName']} />
		</Section>
	);
}
